var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 163","d":"M8.213 15.557l-4.679.068a.644.644 0 0 1-.521-1.036L14.021.189a.479.479 0 0 1 .774.016l10.089 14.441a.647.647 0 0 1-.531 1.018h-3.5a.644.644 0 0 0-.647.622c-.163 4.752-1.178 15.189-6.862 16.456H0c7.858-.694 8.762-13.43 8.866-16.523a.642.642 0 0 0-.653-.662z","fill":"#ddd"}));
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"25","height":"32.742","viewBox":"0 0 25 32.742"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js?name=Icon!./src/components/icons/homeowners-icon-flip-up.svg
// module id = 298
// module chunks = 0